export default {"src":"/_next/static/media/crossWithPaw_64.90fa54e2.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};